import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/* Modules */
import { MaterialModule } from '../modules/material.module';

/* Components */
import { FooterComponent } from './footer/footer.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ProfileMenuComponent } from './navigation/profile-menu/profile-menu.component';
import { NavListComponent } from './navigation/nav-list/nav-list.component';
import { HeaderComponent } from './header/header.component';

/* Pipes */
import { FirstUppercasePipe } from '../pipes/first-uppercase.pipe';
import { CustomSplitPipe } from '../pipes/custom-split.pipe';
import { StorageUnitPipe } from '../pipes/storage-unit.pipe';
import { ReplacePipe } from '../pipes/replace.pipe';
import { OrderByPipe } from '../pipes/orderby.pipe';

const PIPES = [FirstUppercasePipe, CustomSplitPipe, StorageUnitPipe, ReplacePipe, OrderByPipe];
const COMPONENTS = [FooterComponent, BreadcrumbComponent, ProfileMenuComponent, HeaderComponent, NavListComponent];
@NgModule({
  declarations: [...COMPONENTS, ...PIPES],
  imports: [CommonModule, RouterModule, MaterialModule, FormsModule, ReactiveFormsModule],
  exports: [...COMPONENTS, ...PIPES],
  providers: [DatePipe]
})
export class SharedComponentModule {}
